import { Container } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React from 'react'

function SortbarLoader() {
    return (
        <Container className="flex flex-middle flex-between">
            <Stencil shimmer height="62px" width="227px" borderRadius="12px" />
            <Stencil shimmer height="62px" width="227px" borderRadius="12px" />
        </Container>
    )
}

export default SortbarLoader
